import React from 'react';
import {get} from 'lodash';
import {gql} from 'apollo-boost';

import client from '../../../src/graphql/client';

import CategoryPage from '../../../src/containers/Community/Category';

import refactorBreadcrumbsData from '../../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorHb from '../../../src//data-restructure/multimedia/hero-banner-small-v2-2023';
import respImgQuery from '../../../src/graphql/queries/resp-img';
import refactorRespImg from '../../../src/data-restructure/ui/resp-img';
import seoQuery from '../../../src/graphql/queries/seo';

const Category = (props) => {
  return (
  	<CategoryPage
      {...props}
		/>
  )
}

export async function getStaticPaths() {
  
  const GET_DYNAMIC_ARTICLES_CATEGORIES_QUERY = gql`
    query GET_ARTICLES_CATEGORIES_PATHS {
			articleCategories {
				nodes {
          slug
				}
			}
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_ARTICLES_CATEGORIES_QUERY
  });

  let paths = [];
  
  const articles = get(result, 'data.articleCategories.nodes', []);

  articles.forEach(item => {
    const slug = get(item, 'slug', null);

    paths.push({
      params: {
        slug: slug
      }
    });
  });

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = process.env.DEV_ASSIGNED_DOMAIN ? process.env.DEV_ASSIGNED_DOMAIN : process.env.ASSIGNED_DOMAIN.toLowerCase()

  const GET_PAGE_CONTEXT = gql`
    query GET_COMMUNITY_PAGE {
      pageBy(uri: "community?${countryCode}") {
        title
        seo {
          ${seoQuery}
        }
        uri
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcHeroBannerV22023 {
              fieldGroupName
              hb2Banners {
                hb2Title
                hb2Subtext
                hb2Image {
                  ${respImgQuery}
                }
                hb2VideoDesktop {
                  guid
                }
                hb2VideoMobile {
                  guid
                }
                hb2Link {
                  title
                  url
                  target
                }
              }
            }
          }
        }
      }
    }
  `

  const GET_CATEGORY_LINKS = gql`
    query GET_CATEGORIE {
      articleCategories {
        nodes {
          name
          slug
          articles(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  `

  const GET_CATEGORIES = gql`
    query GET_CATEGORIE($slug: String) {
      articleCategories(where: {slug: $slug}) {
        nodes {
          slug
          id
          name
          articles(first:1000) {
            nodes {
              id
              uri
              title
              date
              articleCategories {
                nodes {
                  name
                  slug
                }
              }
              acf_article {
                artDatePosted
                artTeaserCopy
                artThumbnailImage {
                  ${respImgQuery}
                }
              }
              acf_domains {
                assignedDomains
              }
            }
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  const categoryProps = await client.query({
    query: GET_CATEGORY_LINKS
  });

  const pageProps = await client.query({
    query: GET_CATEGORIES,
    variables: {
      slug: params.slug
    }
  });

  if (categoryProps) {
    const context = get(contextProps, 'data.pageBy', null);

    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = hbData && hbData[0] ? refactorHb(hbData[0]) : null;

    const categoryNodes = get(categoryProps, 'data.articleCategories.nodes', null);

    const categories = categoryNodes ? categoryNodes.filter(item => {
      return get(item, 'articles.edges', []).length > 0 
    }) : null;

    const name = get(pageProps, 'data.articleCategories.nodes[0].name', null);
    const slug = get(pageProps, 'data.articleCategories.nodes[0].slug', null);
    const articles = get(pageProps, 'data.articleCategories.nodes[0].articles.nodes', null);

    const articleConversion = articles.filter(item => {
      const articleAssignedDomains = get(item, 'acf_domains.assignedDomains', []);
      return articleAssignedDomains.indexOf(domain) !== -1;
    }).map(item => {
      const title = item.title;
      const date = item.date;
      const teaser = item.acf_article.artTeaserCopy;
      const uri = item.uri ? item.uri.replace('-ccau', '').replace('-ccnz', '') : null;
      const category = item.articleCategories.nodes[0].name;
      const img = item.acf_article.artThumbnailImage ? refactorRespImg(item.acf_article.artThumbnailImage, [{
        size: 'default',
        key: 'image_size_466x314'
      }]) : null;
  
      return {
        id: item.id,
        title,
        date,
        teaser,
        uri,
        category,
        img
      }
    })

    const assignedDomains = get(context, 'acf_domains.assignedDomains', []); 

    // breadcrumbs
    const categoryUrl = slug ? '/community/category/' + slug : false;
    const breadcrumbs = categoryUrl ? await refactorBreadcrumbsData(categoryUrl, assignedDomains) : null;

    const data = {
      meta: {
        title: context.title,
        seo: context.seo
      },
      breadcrumbs,
      heroBanner,
      categories,
      name,
      slug,
      articleConversion
    }

    return {
      props: {
        ...data,
      }
    }
  } else { 
    return { props: {} }
  }
}

export default Category